import React from "react";
import { saveActivity } from "../../common/commonService";
import { ImageComponent, Bullets, ContentDiv, ButtonsNeeded, imagesList } from './LearnMoreComponent';
import "./LearnMore.css"

class LearnMore extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 1
    };
  }
  componentDidMount() {
  }
  prev() {
    if (this.state && this.state.count > 1) {
      this.sendWhizEvent('Prev');
      this.setState({ count: this.state.count - 1 });
    }
  }
  reset() {
    this.sendWhizEvent('LearnMore');
    this.props.openFandamentPositionCourse();
  }
  next() {
    let track = {}
    track.hit_page = 'MyGame Learn More Page'
    track.hit_type = 'learnMore'
    track.hit_attribute1 = "step " + (this.state.count)
    saveActivity(track);
    this.sendWhizEvent('Next');
    if (this.state.count < imagesList.length) {
      this.setState({ count: this.state.count + 1 });
    } else {
      // console.log("last-page");
      this.setState({ count: 1 });
    }
  }


  sendWhizEvent = hitType => {
    const { count } = this.state;
    console.log("from learn more sendwhizevent method");
    saveActivity({
      hit_page: 'MyGameLearnAboutPositionsPage',
      hit_type: hitType,
      hit_attribute1: imagesList[count - 1].content.title,
      hit_attribute3: this.props.gameType,
    });
  }

  render() {
    return <div id="landingPageLearnMoreModal" className="modal fade" data-backdrop="static" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog ENM_ModalDialog learnMore_modal_content">
        <div className="learnMore_header_wrap">
          <div className="learnMore_title" data-e2e="learn about positions">
            Learn About Position
          </div>
          <div className="learnMore_close_button">
            <i className="fa fa-lg fa-times cursor-pointer" data-e2e="close" style={{ fontSize: "23px" }} data-dismiss="modal" onClick={()=>{
              this.setState({ count: 1 })
            }}></i>
          </div>
        </div>
        <div className="learnMore_content_wrapper">
          <ImageComponent index={this.state.count} baseUrlImg={this.props.baseUrlImg} />
          <ContentDiv index={this.state.count} />
          <ButtonsNeeded index={this.state.count} prev={() => this.prev()} next={() => this.next()} skip={() => this.skip()}
            reset={() => this.reset()} />
        </div>
      </div>
    </div>

  }
}
export default LearnMore;


/** WEBPACK FOOTER **
 ** ./src/components/LearnMore/LearnMore.js
 **/